import { render, staticRenderFns } from "./DictionaryForm.vue?vue&type=template&id=03e2748a&scoped=true"
import script from "./DictionaryForm.vue?vue&type=script&lang=js"
export * from "./DictionaryForm.vue?vue&type=script&lang=js"
import style0 from "./DictionaryForm.vue?vue&type=style&index=0&id=03e2748a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2748a",
  null
  
)

export default component.exports